import React, {
  RefObject,
} from 'react';
import {
  NumberedProcessItem,
  TitleDescriptionItem,
} from 'views/EMR/components/PCC/Walkthrough/components/ContentPrimitives';
import PageIntroduction from 'views/EMR/components/PCC/Walkthrough/components/PageIntroduction';
import type {
  ProcessPageDefinition,
} from 'views/EMR/components/PCC/Walkthrough/types';

type Props = {
  page: ProcessPageDefinition;
  headingRef: RefObject<HTMLHeadingElement | null>;
};

export default function ProcessPage({
  page,
  headingRef,
}: Props) {
  return (
    <div className="flex flex-col gap-7">
      <PageIntroduction
        eyebrow={page.introduction.eyebrow}
        heading={page.introduction.heading}
        description={page.introduction.description}
        headingRef={headingRef}
      />

      <div className="flex flex-col gap-5 rounded-2xl border border-[#E2E8F0] bg-white p-5 sm:p-7 lg:flex-row">
        {page.steps.map((step, index) => (
          <NumberedProcessItem
            key={step.title}
            number={index + 1}
            title={step.title}
            description={step.description}
            showConnector={index < page.steps.length - 1}
          />
        ))}
      </div>

      <div className="flex flex-col gap-4">
        <h2 className="m-0 text-lg font-bold text-[#0F1B2D]">
          {page.teamSection.title}
        </h2>
        <div className="grid grid-cols-1 gap-x-7 gap-y-[18px] sm:grid-cols-2 lg:grid-cols-3">
          {page.teamSection.items.map((item) => (
            <TitleDescriptionItem
              key={item.title}
              title={item.title}
              description={item.description}
              iconKey={item.iconKey}
              iconVariant="pale"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
